import {
  ADD_SIMPLE_PRODUCT_TO_CART,
  ADD_BUNDLE_PRODUCT_TO_CART,
  ADD_CONFIGURABLE_PRODUCT_TO_CART,
  UPDATE_CART,
  REMOVE_FROM_CART,
  GUEST_VIEW_CART,
  GUEST_RESET_CART,
  SET_SHIPPING_METHOD,
  SET_SHIPPING,
  SET_BILLING,
  ADD_COUPON_CODE,
  REMOVE_COUPON_CODE,
  GET_SHIPPING_BILLING,
  GUEST_CART_ITEMS,
  IS_MULTICART,
} from "../actionTypes/index";
import {
  validateOrderItems,
  mapCartProductItems,
  valOrNull
} from "../../utils/helperServices";

const initialState = {
  totalQuantity: 0,
  cartProductItems: [],
  prices: null,
  shipping_address: null,
  billing_address: null,
  available_payment_methods: [],
  selected_shipping_method: null,
  shippingMessageText: null,
  shippingFeeCalculate: null,
  cartLimits: null,
  errorMsg: null,
  applied_coupons: null,
  notificationData: null,
  allow_place_order: 1,
  guestCartItems: [],
  guestCartQty: 0,
  guestCoupons: null,
  isMulti: false,
  contract: false,
  contractMissed: false,
  onceOff: false,
  onceOffMissed: false,
  hasPreOrder: false,
  hasBackOrder: false,
};

function getShippingMethodValue(addresses) {
  if (!addresses) { return null; }
  if (Array.isArray(addresses) && addresses.length > 0) {
    return addresses[0].selected_shipping_method;
  }
  return addresses.selected_shipping_method;
}

function getShipAndBillValue(payload) {
  if (payload && payload.setAddress) {
    return payload.setAddress;
  } else if (payload && payload.updatedAddress) {
    return payload.updatedAddress;
  } else {
    return null;
  }
}

const cartReducer = (state = initialState, { type, payload }) => {
  let shoppingCart, cartItems;
  switch (type) {
    case GUEST_VIEW_CART:
      shoppingCart = (payload && payload?.cart) || {};
      cartItems = mapCartProductItems(shoppingCart?.items || []);

      return {
        ...state,
        ...validateOrderItems(cartItems),
        applied_coupons: valOrNull(shoppingCart?.applied_coupons),
        cartProductItems: cartItems,
        totalQuantity: shoppingCart?.total_quantity || 0,
        prices: valOrNull(shoppingCart?.prices),
        shippingMessageText: valOrNull(shoppingCart?.shippingMessageText),
        shippingFeeCalculate: valOrNull(shoppingCart?.shipping_fee_calculate),
        cartLimits: valOrNull(shoppingCart?.cart_order_limits),
        notificationData: valOrNull(shoppingCart?.notification_data),
        allow_place_order: shoppingCart?.allow_place_order,
        available_payment_methods: shoppingCart?.available_payment_methods,
      };
    case GUEST_CART_ITEMS:
      return {
        ...state,
        guestCartItems: payload ? payload.products : [],
        guestCartQty: payload ? payload.totalItems : 0,
        guestCoupons: payload ? payload.coupon : null,
      };
    case GET_SHIPPING_BILLING:
      shoppingCart = (payload && payload?.cart) || {};

      return {
        ...state,
        shipping_address: valOrNull(shoppingCart?.shipping_addresses),
        billing_address: valOrNull(shoppingCart?.billing_address),
        selected_shipping_method: getShippingMethodValue(shoppingCart?.shipping_addresses),
      };
    case ADD_SIMPLE_PRODUCT_TO_CART:
      shoppingCart = (payload && payload?.addSimpleProductsToCart?.cart) || {};
      cartItems = mapCartProductItems(shoppingCart?.items || []);

      return {
        ...state,
        ...validateOrderItems(cartItems),
        totalQuantity: shoppingCart?.total_quantity || 0,
        cartProductItems: cartItems,
        prices: valOrNull(shoppingCart?.prices),
        shippingMessageText: valOrNull(shoppingCart?.shippingMessageText),
        shippingFeeCalculate: valOrNull(shoppingCart?.shipping_fee_calculate),
        selected_shipping_method: getShippingMethodValue(shoppingCart?.shipping_addresses),
        cartLimits: valOrNull(shoppingCart?.cart_order_limits),
      };
    case ADD_BUNDLE_PRODUCT_TO_CART:
      shoppingCart = (payload && payload?.addBundleProductsToCart?.cart) || {};
      cartItems = mapCartProductItems(shoppingCart?.items || []);

      return {
        ...state,
        ...validateOrderItems(cartItems),
        totalQuantity: shoppingCart?.total_quantity || 0,
        cartProductItems: cartItems,
        prices: valOrNull(shoppingCart?.prices),
        shippingMessageText: valOrNull(shoppingCart?.shippingMessageText),
        shippingFeeCalculate: valOrNull(shoppingCart?.shipping_fee_calculate),
        selected_shipping_method: getShippingMethodValue(shoppingCart?.shipping_addresses),
        cartLimits: valOrNull(shoppingCart?.cart_order_limits),
        errorMsg: payload && payload?.errors?.length > 0 &&
          payload.errors[0]?.message
          ? payload.errors[0].message
          : null,
      };
    case ADD_CONFIGURABLE_PRODUCT_TO_CART:
      shoppingCart = (payload && payload?.addConfigurableProductsToCart?.cart) || {};
      cartItems = mapCartProductItems(shoppingCart?.items || []);

      return {
        ...state,
        ...validateOrderItems(cartItems),
        totalQuantity: shoppingCart?.total_quantity || 0,
        cartProductItems: cartItems,
        prices: valOrNull(shoppingCart?.prices),
        shippingMessageText: valOrNull(shoppingCart?.shippingMessageText),
        shippingFeeCalculate: valOrNull(shoppingCart?.shipping_fee_calculate),
        selected_shipping_method: getShippingMethodValue(shoppingCart?.shipping_addresses),
        cartLimits: valOrNull(shoppingCart?.cart_order_limits),
      };
    case UPDATE_CART:
      shoppingCart = (payload && payload?.updateCartItems?.cart) || {};
      cartItems = mapCartProductItems(shoppingCart?.items || []);

      return {
        ...state,
        ...validateOrderItems(cartItems),
        totalQuantity: shoppingCart?.total_quantity || 0,
        cartProductItems: cartItems,
        prices: valOrNull(shoppingCart?.prices),
        cartLimits: valOrNull(shoppingCart?.cart_order_limits),
        errorMsg:
          payload &&
            payload.errors &&
            payload.errors.length > 0 &&
            payload.errors[0].message
            ? payload.errors[0].message
            : null,
      };
    case REMOVE_FROM_CART:
      shoppingCart = (payload && payload?.removeItemFromCart?.cart) || {};
      cartItems = mapCartProductItems(shoppingCart?.items || []);

      return {
        ...state,
        ...validateOrderItems(cartItems),
        totalQuantity: shoppingCart?.total_quantity || 0,
        cartProductItems: cartItems,
        prices: valOrNull(shoppingCart?.prices),
        selected_shipping_method: getShippingMethodValue(shoppingCart?.shipping_addresses),
        cartLimits: valOrNull(shoppingCart?.cart_order_limits),
      };
    case SET_SHIPPING_METHOD:
      shoppingCart = (payload && payload?.shippingMethod?.cart) || {};

      return {
        ...state,
        selected_shipping_method: getShippingMethodValue(shoppingCart?.shipping_addresses),
      };
    case SET_SHIPPING:
      return {
        ...state,
        shipping_address: payload ? getShipAndBillValue(payload) : null,
      };
    case SET_BILLING:
      return {
        ...state,
        billing_address: payload ? getShipAndBillValue(payload) : null,
      };
    case ADD_COUPON_CODE:
      return {
        ...state,
        prices:
          payload && payload.errors
            ? state.prices
            : payload &&
              payload?.applyCouponToCart?.cart.prices
              ? payload.applyCouponToCart.cart.prices
              : null,
        applied_coupons: payload && payload?.applyCouponToCart?.cart?.applied_coupons,
        errorMsg:
          payload &&
            payload.errors &&
            payload.errors.length > 0 &&
            payload.errors[0].message
            ? payload.errors[0].message
            : null,
      };
    case REMOVE_COUPON_CODE:
      return {
        ...state,
        applied_coupons: null,
        prices:
          payload && payload?.removeCouponFromCart?.cart?.prices
            ? payload.removeCouponFromCart.cart.prices
            : null,
      };
    case GUEST_RESET_CART:
      return {
        ...state,
        ...initialState,
      }
    case IS_MULTICART:
      return {
        ...state,
        isMulti: payload
      }
    default:
      return state;
  }
};

export default cartReducer;
